import { useEffect } from 'react';
import { AxiosResponse } from 'axios';
import { useMutation } from '@tanstack/react-query';
import * as service from '../services';
import { useDebounce } from '../../../../../hooks';
import { useAnaliseCoberturaStore } from '../AnaliseCobertura.store';

export const useCoverageAnalysisCity = () => {
  const { setCoverageAnalysisState, cityCoverageParams } = useAnaliseCoberturaStore();

  const debounce = useDebounce(500);

  const cityCoverageSuccess = (data: AxiosResponse) => {
    setCoverageAnalysisState('cityCoverageData', data.data);
  };

  const mutation = useMutation({
    mutationFn: data => service.getCoverageAnalysisCity(data),
    onSuccess: data => cityCoverageSuccess(data),
  });

  const handleChangeCityCoveragePeriod = (value: number) => {
    const state = useAnaliseCoberturaStore.getState();
    const param = { ...state.cityCoverageParams, diasAnalise: value };
    setCoverageAnalysisState('cityCoverageParams', param);
    mutation.mutateAsync(param);
  };

  const handleChangeCityCoverageSearch = (value: number) => {
    const state = useAnaliseCoberturaStore.getState();
    const param = { ...state.cityCoverageParams, query: value, page: 0 };
    debounce(() => {
      setCoverageAnalysisState('cityCoverageParams', param);
      mutation.mutateAsync(param);
    });
  };

  const handleChangeCityCoveragePagination = (value: number) => {
    const state = useAnaliseCoberturaStore.getState();
    const param = { ...state.cityCoverageParams, page: value - 1 };
    setCoverageAnalysisState('cityCoverageParams', param);
    mutation.mutateAsync(param);
  };

  useEffect(() => {
    mutation.mutateAsync(cityCoverageParams);
  }, []);

  return {
    cityCoverageLoading: mutation.isPending,
    handleChangeCityCoveragePeriod,
    handleChangeCityCoverageSearch,
    handleChangeCityCoveragePagination,
  };
};
